<script>
    import { onMount } from 'svelte';
    import { fade, fly } from 'svelte/transition';
    import { ServerRequest } from '../service/ServerRequest.js';
    import { AppAccessGranted ,UserToken, UserData } from '../stores/LoggedUser.js';
    import FloatMenu from '../components/FloatMenu.svelte';
    import { EventSelected } from '../stores/EventSelected';

    let token = $UserToken;
    let menu_open = false;
    let orderList = [];
    let showPanel = false;

    onMount( () => {
        if( $AppAccessGranted != 'true' || $UserToken == '' ){
            logout();
        }

        if( Object.keys($EventSelected).length == 0 ){
            window.location.href = '#/events'
        }
    
        const wait = setTimeout(() => {
            showPanel = true;
            clearTimeout(wait);
        }, 525);
        loadOrders();
    });

     function loadOrders() {
        
        ServerRequest.post(ServerRequest.routes.orders, token, { event_id: $EventSelected.id })
        .then( (resp) => {
            console.log(resp);
            if (resp.status && resp.data) {
                orderList = resp.data;
            }
        });
    }

</script>

{#if showPanel}
<main class="rpgui-content rpgui-cursor-default" 
    in:fly={{ x: 400, duration: 500 }}
    out:fly={{ x: 400, duration: 500 }}
    >
    <div class="main-page-container rpgui-container framed">
        <h1 class="t-18">{$EventSelected.title}</h1>
        <div class="main-page-content">
            <div>
                {#each orderList as order }
                    <div style="background:#a66b34; padding: 1rem; margin-top: .5rem; border-radius: .25rem ">
                        <div class="d-flex justify-between">
                            <div>
                                <h1 class="text-left t-16" style="text-transform: capitalize;">{order.food_name}</h1>
                            </div>
                            <div>
                                <h5 class="badge">{order.user_nickname}</h5>
                            </div>
                        </div>
                        <div>
                            <p style="padding-left: .75rem">
                                {order.food_note}
                            </p>
                        </div>
                    </div>
                {/each}
            </div>
        </div>
    </div>

    <FloatMenu bind:menu_open="{menu_open}" >
        <div class="float-menu__list-item" on:click="{() => { window.location.href = '#/events' }}"> > Eventi</div>
        <div class="float-menu__list-item"> > Profile</div>
    </FloatMenu>
</main>
{/if}